/**
 * @generated SignedSource<<1dab65924f9c16744eaaf71efa50a300>>
 * @relayHash f117fb91c06f881fbe04e95f9257fc16
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e0665bec0712e49315eb39aff9bb1080876bc59e57382be0ffd4f37a469637b1

import type { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type realtimeUpdater_issueDeleted_Subscription$variables = {
  cloudId: string;
  projectId: string;
};
export type realtimeUpdater_issueDeleted_Subscription$data = {
  readonly jira: {
    readonly onIssueDeletedByProject: {
      readonly resource: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type realtimeUpdater_issueDeleted_Subscription = {
  response: realtimeUpdater_issueDeleted_Subscription$data;
  variables: realtimeUpdater_issueDeleted_Subscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectId"
  }
],
v1 = [
  {
    "concreteType": "JiraSubscription",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          },
          {
            "kind": "Variable",
            "name": "projectId",
            "variableName": "projectId"
          }
        ],
        "concreteType": "JiraIssueDeletedStreamHubPayload",
        "kind": "LinkedField",
        "name": "onIssueDeletedByProject",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "resource"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "realtimeUpdater_issueDeleted_Subscription",
    "selections": (v1/*: any*/),
    "type": "Subscription"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "realtimeUpdater_issueDeleted_Subscription",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "e0665bec0712e49315eb39aff9bb1080876bc59e57382be0ffd4f37a469637b1",
    "metadata": {},
    "name": "realtimeUpdater_issueDeleted_Subscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "d3d8f04ee66fc8e4f6135f2e2268776a";

export default node;
